var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyHomeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 388,
    viewBox: "0 0 426 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.7911 119.54L140.352 128.232L149.113 173.95L154.294 200.98L141.818 189.369L104.56 229.401L42.0035 171.179L79.2618 131.147L66.7911 119.54Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.331 124.365L118.23 115.878L107.936 106.297L92.8795 122.474",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1498 192.491L84.8105 172.441L99.0538 185.697L80.3931 205.747L66.1498 192.491Z",
    fill: "white",
    stroke: "#6F7C87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.413 192.535L84.79 171.715L97.2114 183.275",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3792 206.465L99.7562 185.646L87.3359 174.086",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.974 201.659V201.359L252.71 201.218C224.614 186.193 211.063 157.963 211.063 126.801C211.063 80.3338 247.925 43.4727 294.392 43.4727C340.693 43.4727 377.456 80.0697 377.72 126.301H377.707V126.801C377.707 145.897 373.53 163.872 364.165 178.357C354.806 192.833 340.247 203.857 319.409 209.034L319.03 209.128V209.519V248.059V248.559H319.118C319.117 265.914 319.096 281.881 319.074 293.544C319.063 299.432 319.052 304.223 319.044 307.542C319.04 309.201 319.036 310.493 319.034 311.369L319.031 312.367L319.03 312.622L319.03 312.686L319.03 312.702L319.03 312.706L319.03 312.707C319.03 312.707 319.03 312.708 319.06 312.708L319.03 312.708V312.709V351.92L289.768 386.16H252.974V352.442L269.55 339.343L269.74 339.193V338.951V325.702V325.487L269.584 325.339L252.974 309.577V298.473L269.615 279.655L269.74 279.513V279.324V266.075V265.833L269.55 265.683L252.974 252.584V201.659ZM267.95 101.466C267.95 116.081 279.793 127.923 294.407 127.923C309.021 127.923 320.864 116.081 320.864 101.466C320.864 86.852 309.021 75.0098 294.407 75.0098C279.793 75.0098 267.95 86.852 267.95 101.466Z",
    fill: "#A3C5EB",
    stroke: "#6F7C87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M319.535 248.074V209.519C361.446 199.107 378.211 165.13 378.211 126.801C378.211 80.0577 341.126 42.9727 294.383 42.9727C247.639 42.9727 210.554 80.0577 210.554 126.801C210.554 158.11 224.175 186.524 252.464 201.659V252.826L269.23 266.075V279.324L252.464 298.283V309.792L269.23 325.702V338.951L252.464 352.2V386.66H289.988L319.52 352.105V312.709C319.52 312.709 311.207 280.596 347.765 280.596H426.001",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M294.389 126.802C308.276 126.802 319.534 115.544 319.534 101.657C319.534 87.7695 308.276 76.5117 294.389 76.5117C280.502 76.5117 269.244 87.7695 269.244 101.657C269.244 115.544 280.502 126.802 294.389 126.802Z",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.655 101.668C183.783 91.0152 177.034 76.1651 177.034 59.7429C177.034 27.3374 203.305 1.06641 235.711 1.06641C268.116 1.06641 294.387 27.3374 294.387 59.7429V76.5087",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.271 59.7422H109.974L1 168.716L101.595 269.303L193.803 177.095",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyHomeImage);
export default __webpack_public_path__ + "static/media/KeyHome-Image.c25da70e.svg";
export { ForwardRef as ReactComponent };